import { render, staticRenderFns } from "./lianxi.vue?vue&type=template&id=76fe57f9&scoped=true"
import script from "./lianxi.vue?vue&type=script&lang=js"
export * from "./lianxi.vue?vue&type=script&lang=js"
import style0 from "./lianxi.vue?vue&type=style&index=0&id=76fe57f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fe57f9",
  null
  
)

export default component.exports